import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { GRID2D_CELL__empty } from './GRID2D_CELL__empty';
import { GRID2D_CELL__image_content } from './GRID2D_CELL__image_content';

export interface PROPS__grid2d_cell {
  entity: DTO__entity_with_grid2d;
  grid2d: DTO__grid2d;
  cell: DTO__grid2d_cell;
  can_show_buttons?: boolean;

  className?: string;
  //
  height: number;
  width: number;
  //
  use_offset_from_slug: boolean;
}

export function GRID2D_CELL__image_content_or_empty({
  entity,
  grid2d,
  cell,
  can_show_buttons = true,

  className = '',
  //
  height,
  width,
  //
  use_offset_from_slug,
}: PROPS__grid2d_cell) {
  /*
   * RENDERS
   */

  function render_view() {
    let out = <></>;

    if (cell.hash_sha256_content.is_empty_hash_sha256()) {
      out = <GRID2D_CELL__empty key={cell._id} {...{ height, width }} is_hovered={false} />;
    } else {
      out = <GRID2D_CELL__image_content key={cell._id} {...{ entity, grid2d, cell, can_show_buttons, className, width, height, use_offset_from_slug }} />;
    }

    return out;
  }

  /*
   * HTML
   */
  return render_view();
}
